import { QuestionnaireType, UserQuestionnaireType } from './types';

type NormalizeQuestionnaireProps = (
  questionnaire: UserQuestionnaireType,
  isUnclearQuestionsFlow?: boolean
) => UserQuestionnaireType;

const normalizeAssessmentQuestionnaire = (questionnaire: QuestionnaireType): QuestionnaireType => {
  const newSections = questionnaire.sections.map((section, i) => {
    const newSurveyItems = section.surveyItems.map((surveyItem) => {
      if (surveyItem.type === 'sectionDivider') surveyItem.orderNumber = i + 1;
      return surveyItem;
    });

    return { ...section, surveyItems: newSurveyItems };
  });
  return { ...questionnaire, sections: newSections };
};

const normalizeScreeningQuestionnaire = (questionnaire: QuestionnaireType): QuestionnaireType => {
  if (questionnaire.sections[questionnaire.sections.length - 1].id.includes('result')) return questionnaire;

  const condition = questionnaire.condition || '';

  questionnaire.sections.push({
    id: 'summary',
    name: 'Summary',
    description: 'Test result summary',
    surveyItems: [
      {
        id: 'summary',
        label: condition,
        whyWeAskExplanation: undefined,
        skippable: false,
        description: undefined,
        type: 'summary',
        surveyItemType: 'question',
      },
    ],
  });

  questionnaire.sections.push({
    id: 'result',
    name: 'Result',
    description: 'Test result',
    surveyItems: [
      {
        id: 'result',
        label: questionnaire.sections[0].name,
        whyWeAskExplanation: undefined,
        skippable: false,
        description: undefined,
        type: 'result',
        surveyItemType: 'question',
      },
    ],
  });

  return questionnaire;
};

export const normalizeQuestionnaire: NormalizeQuestionnaireProps = (
  userQuestionnaire,
  isUnclearQuestionsFlow = false
) => {
  if (isUnclearQuestionsFlow)
    return {
      ...userQuestionnaire,
      unclearAnswersFlow: userQuestionnaire.answers.filter(({ answer }) => answer && answer.type === 'iDontKnow'),
    };

  switch (userQuestionnaire.questionnaire.type) {
    case 'screening':
      return { ...userQuestionnaire, questionnaire: normalizeScreeningQuestionnaire(userQuestionnaire.questionnaire) };
    case 'assessment':
    default:
      return {
        ...userQuestionnaire,
        questionnaire: normalizeAssessmentQuestionnaire(userQuestionnaire.questionnaire),
      };
  }
};
